module.exports = ({ images, exteriorImages, interiorImages }) => {
  let modalPaths = ['/book-a-test-drive', '/reserve', '/ask-a-question']

  if (images && images.length) {
    modalPaths = [
      ...modalPaths,
      '/gallery',
      ...images.map((_, i) => `/gallery/${i + 1}`)
    ]
  }

  if (exteriorImages && exteriorImages.length) {
    modalPaths.push('/exterior-360')
  }

  if (interiorImages && interiorImages.length) {
    modalPaths.push('/interior-360')
  }

  return modalPaths
}
